var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_42276)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#EBF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.634 21.5C50.0189 20.8333 50.9811 20.8333 51.366 21.5L79.0788 69.5C79.4637 70.1667 78.9826 71 78.2128 71H22.7872C22.0174 71 21.5363 70.1667 21.9212 69.5L49.634 21.5Z",
    fill: "white",
    stroke: "#386937",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 41C47.5 39.3431 48.8431 38 50.5 38C52.1569 38 53.5 39.3431 53.5 41V53C53.5 54.6569 52.1569 56 50.5 56C48.8431 56 47.5 54.6569 47.5 53V41Z",
    fill: "#386937"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 61,
    r: 3,
    fill: "#386937"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_42276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorModal);
export default __webpack_public_path__ + "static/media/errorModal.1a07fa6e13976da7f8d459b088e49357.svg";
export { ForwardRef as ReactComponent };